import { render, staticRenderFns } from "./DrawListContainer.vue?vue&type=template&id=0fae0458&scoped=true&"
import script from "./DrawListContainer.vue?vue&type=script&lang=js&"
export * from "./DrawListContainer.vue?vue&type=script&lang=js&"
import style0 from "./DrawListContainer.vue?vue&type=style&index=0&id=0fae0458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae0458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
